import React from "react";
import WorkflowStepRing from "./WorkflowStepRing";
import iso6391 from "iso-639-1";
import {IGroupProgress} from "../../../models/interfaces/groupProgress.interface.ts";
import {IStateEnum} from "../../../models/enums/state.enum.ts";
import {useProject} from "../../../hooks/useProject.ts";

interface Props {
  items: IGroupProgress;
  type: "subtitleTranslations" | "audioDescriptions";
  hoveredStep: string | null;
  setHoveredStep: (id: string | null) => void;
  goBack: () => void;
  downloadSpecific: (type: string, lang: string) => void;
}

const LanguageLevel: React.FC<Props> = (
  {
    items,
    type,
    hoveredStep,
    setHoveredStep,
    goBack,
    downloadSpecific
  }) => {
  const entries = Object.entries(items || {});
  const {getItemStateEnum} = useProject()

  return (
    <div className="flex items-center justify-start gap-4">
      <div className="flex-shrink-0 w-10 h-10">
        <WorkflowStepRing
          id="arrow-prev"
          rotation={360}
          state={IStateEnum.IN_PROGRESS}
          icon="arrow-prev"
          isInteractive
          isHovered={hoveredStep === "arrow-prev"}
          onEnter={() => setHoveredStep("arrow-prev")}
          onLeave={() => setHoveredStep(null)}
          onClick={goBack}
        />
      </div>
      {entries.map(([lang, progress]) => {
        const rotation = (progress.pct / 100) * 360;
        const itemState = getItemStateEnum(progress)
        return (
          <div key={lang} className="flex-shrink-0 w-10 h-10">
            <WorkflowStepRing
              id={lang}
              rotation={rotation}
              state={itemState}
              isInteractive={progress.pct === 100 && itemState === IStateEnum.DONE}
              isHovered={hoveredStep === lang}
              onEnter={() => setHoveredStep(lang)}
              onLeave={() => setHoveredStep(null)}
              onClick={() => {
                if (progress.pct === 100) {
                  downloadSpecific(type, lang);
                }
              }}
              tooltip={iso6391.getName(lang)}
              content={<span>{lang.toUpperCase()}</span>}
            />
          </div>
        );
      })}
    </div>
  );
};

export default LanguageLevel;
